<template>
    <div>
      <AdminViewPR/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import AdminViewPR from '@/components/EmployeeViewPR.vue'
  
  export default {
    name: 'pr-summary',
    components: {
      AdminViewPR
    }
  }
  </script>
  